import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import SubtleLowPolyBackground from './components/LowPolyBackground/LowpollyNoColors';
import CustomCursor from './components/customCursor/cursor';
import ProjectGallery from './components/ProjectGallery/ProjectGallery';
import ReactGA from "react-ga4";
import CookieConsent from './components/CookieManager/CookieManager';

const App = () => {
  const [activeSection, setActiveSection] = useState('about');
  const [currentTime, setCurrentTime] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [analyticsInitialized, setAnalyticsInitialized] = useState(false);


  
  const initializeAnalytics = useCallback(() => {
  if (!analyticsInitialized) {
    ReactGA.initialize("G-GNT1V5EHNK");
    ReactGA.set({ page: window.location.pathname });
    setAnalyticsInitialized(true);
  }
}, [analyticsInitialized]);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      initializeAnalytics();
    }
  }, [initializeAnalytics]);


  const handleCookieAccept = () => {
    initializeAnalytics();
  };

    const handleCookieReject = () => {
    setAnalyticsInitialized(false);
  };

  //Tracking de Clicks
  const trackButtonClick = (category, action, label) => {
    ReactGA.event({
      category,   
      action,     
      label        
    });
  };
  
  useEffect(() => {
    const updateTime = () => {
      const time = new Date().toLocaleTimeString('en-GB', { 
        hour: '2-digit', 
        minute: '2-digit', 
        timeZone: 'Europe/Lisbon' 
      });
      setCurrentTime(time + ' LISBON');
    };

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);


  const sections = [
    { id: 'about', title: 'About' },
    { id: 'projects', title: 'Projects' },
    { id: 'experience', title: 'Experience' },
    { id: 'contact', title: 'Contact' }
  ];


  const skillsVisible = [
    'JavaScript', 'React', 'TypeScript', 'Node.js', 'Vitest', '.NET / ASP.NET',
    'NestJS', 'Git', 'MySQL', 'REST APIs',
  ];

  const skillsHidden = [
    'Angular', 'Express.js', 'Strapi', '.NET / ASP.NET',
    'Jest', 'Playwright', 'Vitest',
    'MySQL', 'SQL',
    'PHP', 'C#', 'Java', 'C++',
    'Docker', 'CI/CD', 'Agile / Scrum',
    'UML', 'BPMN', 'OOP', 'Software Architecture',
  ];


  const projects = [
    {
      id: 1,
      title: 'FlipChar',
      year: '2026',
      description: 'Built as a learning project to understand how Chrome extensions work. FlipChar is a simple case-conversion tool where users can paste text and choose an option to transform it (e.g., uppercase, lowercase).',
      tech: ['Javascript', 'HTML','CSS'],
      images: [
        '/projects/flipchar/demo1.png',
        '/projects/flipchar/demo2.png'
       
      ]
    },
    {
      id: 2,
      title: 'Secretariado',
      year: '2024/2025',
      description: 'Architected and led development of a comprehensive event management platform serving 900+ attendees across pharmaceutical congresses. With a custom form builder for dynamic registration workflows, self-check-in terminals with QR code integration and automated badge printing, plus real-time attendee dashboards.',
      tech: ['NestJS', 'React','TypeScript', 'PostgreSQL'],
      images: [
        '/projects/secretariado/secretariadoDemo.jpeg',
        '/projects/secretariado/image1.png'
       
      ]
    },
    {
      id: 3,
      title: 'ContentHub Platform',
      year: '2025',
      description: 'Built scalable content platform for pharmaceutical marketing teams, featuring curated news feeds, budget-controlled asset ordering, and workflow management for promotional materials. Designed modular architecture supporting client-specific customizations, including advanced asset derivation.',
      tech: ['React', 'Nestjs', 'TypeScript', 'MySQL'],

    }
  ];

  const openGallery = (project) => {
    setSelectedProject(project);
    setIsGalleryOpen(true);
    trackButtonClick('Projects', 'Opened Gallery', project.title);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };

  const SkillsWithToggle = () => {
    const [expanded, setExpanded] = useState(false);
  
    return (
      <div className="skills-wrapper">
        <div className="skills-list">
          {skillsVisible.map((skill, index) => (
            <span key={index} className="skill-item">{skill}</span>
          ))}
  
          {expanded && skillsHidden.map((skill, index) => (
            <span
              key={`hidden-${index}`}
              className="skill-item skill-item--revealed"
            >
              {skill}
            </span>
          ))}
        </div>
  
        <button
          className="skills-toggle"
          onClick={() => setExpanded(!expanded)}
        >
          <div className='terminal-prompt'>{expanded ? '[ — show less ]' : '[ + show more ]'}</div>
        </button>
      </div>
    );
  };
  

  const renderAboutContent = () => (
    <div className="content-section">
      <div className="hero-section">
        <h1 className="main-title">Rúben Dâmaso</h1>
        <p className="subtitle">Full-Stack Developer</p>
        
        <div className="bio-text">
          <p>
          I'm a Software Engineer with experience in leadership and software development.
I enjoy turning ideas into practical solutions and finding ways to make systems simpler and more efficient.

Technology inspires me because it solves real problems and creates impact in people's lives. I'm especially focused on web development with NestJS and React — areas where I'm constantly learning, building, and experimenting.
          </p>
        </div>

        <div className="info-grid">
          <div className="info-item">
            <span className="label">Education</span>
            <span className="value">Bachelor's degree in software engineering</span>
          </div>
          
          <div className="info-item">
            <span className="label">Focus</span>
            <span className="value">Full-Stack Development</span>
            <span className="value">Software development management</span>
          </div>
          
          <div className="info-item">
            <span className="label">Skills</span>
            {/* <div className="skills-list">
              {skills.map((skill, index) => (
                <span key={index} className="skill-item">{skill}</span>
              ))}
            </div> */}
              <SkillsWithToggle />
          </div>
        </div>
        
        <div className=".info-grid-two">
          <div className="info-item">
            <span className="label">A little bit about myself</span>
            <span className="value">
            Outside of coding, I'm passionate about cinema — from classic masterpieces to the latest releases. I unwind through gaming, whether it's exploring in World of Warcraft, diving into strategy tabletop games, or losing track of time in the Warhammer 40k universe. The mix of lore, creative systems, and strategic thinking that these worlds offer never fails to inspire the way I approach problems in code.
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderProjectsContent = () => (
    <div className="content-section">
      <h2 className="section-title"><span className='highlight-title'>{'//'}</span>Most Recent Work</h2>
      
      <div className="projects-list">
        {projects.map((project, index) => (
          <div key={project.id} className="project-item">
           
            
            <div className="project-header">
              <h3 className="project-title">{project.title}</h3>
              <span className="project-year">{project.year}</span>
            </div>
            
            <p className="project-description">{project.description}</p>
            
            <div className="project-tech">
              {project.tech.map((tech, idx) => (
                <span key={idx} className="tech-tag">{tech}</span>
              ))}
            </div>
            
            <div className="project-actions">
              {project.github && (
                <a 
                  href={project.github} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  View Code →
                </a>
              )}
              {project.images && project.images.length > 0 && (
                <button 
                  className="project-link gallery-button"
                  onClick={() => openGallery(project)}
                >
                  View Gallery →
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

const renderExperienceContent = () => (
  <div className="content-section">
    <h2 className="section-title"><span className='highlight-title'>{'//'}</span>Experience & Background</h2>
    
    <div className="experience-list">
      <div className="experience-item">
        <div className="exp-header">
          <h3>Junior Web Developer</h3>
          <span className="exp-period">March 2026 — On Going</span>
        </div>
        <p className="exp-company">Magebit · Riga, Latvia</p>
        <p className="exp-description">
          Working across various Magento e-commerce websites, contributing to feature development, bug fixes, and ongoing maintenance.
          <br/><br/>
          <em>Stack: PHP, Magento, MySQL, Javascript, Jira</em>
        </p>
      </div>
      <div className="experience-item">
        <div className="exp-header">
          <h3>Lead Full-Stack Engineer</h3>
          <span className="exp-period">June 2024 — February 2026</span>
        </div>
        <p className="exp-company">RHP · Lisbon, Portugal and Remote</p>
        <p className="exp-description">
          Leading technical architecture and full-stack development for healthcare 
          and pharmaceutical clients. Built event management platform serving 900+ 
          attendees, modular content systems for pharma marketing teams, and custom 
          WordPress plugins for healthcare campaigns. Managing complete project 
          lifecycles from requirements to deployment.
          <br/><br/>
          <em>Stack: React, TypeScript, NestJS, MySQL, PostgreSQL, WordPress, PHP, NodeJs</em>
        </p>
      </div>
      
      <div className="experience-item">
        <div className="exp-header">
          <h3>Full-Stack Development Internship</h3>
          <span className="exp-period">March — July 2023</span>
        </div>
        <p className="exp-company">RightCo · Remote</p>
        <p className="exp-description">
          Developed responsive landing pages and web platforms using React and 
          Strapi (Node.js). Collaborated on full-stack applications, implementing 
          features across frontend and backend. Completed with 20/20 grade as 
          part of Higher Professional Technical Course.
          <br/><br/>
          <em>Stack: React, Node.js, Strapi, MySQL</em>
        </p>
      </div>
      
      <div className="experience-item">
        <div className="exp-header">
          <h3>Development Internship</h3>
          <span className="exp-period">April — June 2021</span>
        </div>
        <p className="exp-company">Noble Strategy · Montijo, Portugal</p>
        <p className="exp-description">
          Developed and maintained modular CRM web applications using PHP and 
          CodeIgniter framework. Implemented custom features to meet specific 
          business requirements. First professional experience, completed with 20/20 grade.
          <br/><br/>
          <em>Stack: PHP, CodeIgniter, MySQL</em>
        </p>
      </div>
    </div>
    
    <div className="philosophy-section">
      <h3>What Drives Me</h3>
      <p>
        I get genuinely excited about turning messy requirements into clean, working 
        solutions. Technology solves real problems—whether it's managing in-person 
        events or simplifying marketing workflows. Outside code, I'm deep into 
        cinema, strategy games, and exploring how good storytelling principles apply 
        to software architecture. Always learning, always building.
      </p>
    </div>
  </div>
);

  const renderContactContent = () => (
    <div className="content-section">
      <h2 className="section-title"><span className='highlight-title'>{'//'}</span>Get In Touch</h2>
      
      <div className="contact-info">
        <p className="contact-intro">
          Always open to discussing new projects, creative ideas, or opportunities
        </p>
        
        <div className="contact-methods">
          <div className="contact-item">
            <span className="contact-label">Email</span>
            <a href="mailto:rubendamaso318@gmail.com" className="contact-link">
              rubendamaso318@gmail.com
            </a>
          </div>
          
          <div className="contact-item">
            <span className="contact-label">LinkedIn</span>
            <a 
              href="https://www.linkedin.com/in/r%C3%BAben-d%C3%A2maso/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link"
               onClick={() => {
                trackButtonClick('Contact', 'Clicked LinkedIn', 'LinkedIn Profile');
              }}
            >
              linkedin.com/in/ruben-damaso
            </a>
          </div>
          
          <div className="contact-item">
            <span className="contact-label">GitHub</span>
            <a 
              href="https://github.com/RubenDamaso" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-link"
            >
              github.com/RubenDamaso
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeSection) {
      case 'about':
        return renderAboutContent();
      case 'projects':
        return renderProjectsContent();
      case 'experience':
        return renderExperienceContent();
      case 'contact':
        return renderContactContent();
      default:
        return renderAboutContent();
    }
  };

  return (
    <div className="minimalist-portfolio">
      <SubtleLowPolyBackground></SubtleLowPolyBackground>
      <div className="frame-border">
        <div className="frame-corner top-left"></div>
        <div className="frame-corner top-right"></div>
        <div className="frame-corner bottom-left"></div>
        <div className="frame-corner bottom-right"></div>
      </div>
      
      {/* Header */}
      <header className="portfolio-header">
        <div className="header-left">
          <p className="tagline terminal-prompt">[rúbendâmaso@portfolio]$ _</p>
        </div>
        
        <nav className="main-navigation">
          {sections.map((section) => (
            <button
              key={section.id}
              className={`nav-link ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => setActiveSection(section.id)}
            >
              {section.title}
            </button>
          ))}
        </nav>
      </header>
      
      {/* Main Content */}
      <main className="main-content">
        <div className="content-wrapper">
          {renderContent()}
        </div>
      </main>
      
      {/* Footer */}
      <footer className="portfolio-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span className="copyright"></span>
          </div>
          <div className="footer-right">
            <span className="year">© 2026</span>
          </div>
        </div>
      </footer>
      
      {/* Vertical Text */}
      <div className="vertical-text left">
        <span id='clock'>
          {currentTime}
        </span>
      </div>
      <div className="vertical-text right">
        <span>PORTFOLIO</span>
      </div>
      
      {/* Project Gallery Modal */}
      <ProjectGallery 
        project={selectedProject}
        isOpen={isGalleryOpen}
        onClose={closeGallery}
      />
      
        {window.innerWidth > 768 && <CustomCursor />}
        <CookieConsent 
        onAccept={handleCookieAccept}
        onReject={handleCookieReject}
      />
    </div>
  );
};

export default App;
